export enum IRoutePath {
    default = '/',
    timeOut = '/440',
    notAuthenticated = '/403',
    isAuthenticated = '1'
}
export interface IApiThrowResponse {
    status: boolean;
    statuscode: number,
    messages: string;
    data?: any;
    error?: any;
}
export interface Settings {
    sessionName;
    sessionReset;
    intervalCall;
    showMessageTime;
    dateTimeInterval;
    readerUrl;
    readerRetriveInterval;
    versionCheckInterval;
    idleSelectionTime;
    printerUrl;
    doctorScheduleTimeStart;
    doctorScheduleTimeEnd;
    doctorScheduleIntervelInMinutes;
    staticAppointment;
    existQRString;
    tokenQRString;
    AppointmentCheckIn;
}

export interface IApiUrls {
    apiUrl: string
    component: string;
    methods: IApiMethod[];
}

export interface IApiMethod {
    name: string;
    type: string;
    url: string;
}


export enum IKioskThemes {
    THEME1 = 'theme1',
    THEME2 = 'theme2',
    THEME3 = 'theme3',
    THEME4 = 'theme4',
    THEME5 = 'theme5',
    THEME6 = 'theme6'
}

export enum Ilanguages {
    ENG = '',
    ARB = '-Ar'
}

export enum IMenuCodes {
    REGISTRATION = 'REG',
    APPOINTMENT = 'APPOINTMENT',
    PHARMACY = 'PH',
    LABORATORY = 'LAB',
    FEEDBACK = 'FEEDBACK',
    RADIOLOGY = 'RG',
    CLINICAL = 'CL',
    NONCLINICAL = 'NCL',
    WALKIN = "WI",
    PAYMENT = "PM"


}

export enum IAppoinmentCodes {
    EMIRATESID = 'EMRID',
    MRNID = 'MRNNO',
}
export enum EStatusEnum {
    NACTIVE = 1,
    NINACTIVE = 0
}

export enum EKioskBranchType {
    general = "General",
    custom = "Custom"

}